<ion-item button="true" (click)="goToEditPage(item.id_global, item.id_user)">
  <ion-thumbnail slot="start">
    <img [defaultImage]="defaultImage" [lazyLoad]="blob" alt="img" />
  </ion-thumbnail>
  <ion-label>{{ item.name }}</ion-label>
  <ion-icon *ngIf="!item.id_user" name="globe-outline" size="small" color="primary"></ion-icon>
</ion-item>
